export default "__VITE_ASSET__rgbz1YSS__"